import React, { useEffect, useState } from 'react';
import './Reservations.css';

const Reservations = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="reservations-container">
      <div className="reservations-content">
        <h1 className="reservations-title">Make a Reservation</h1>
        <p className="reservations-description">
          Ready to join us? Use our reservation widget below to secure your spot at Drakes.
        </p>
        <div className="widget-container">
          <iframe 
            id="yelp-reservations-widget" 
            frameBorder="0" 
            width="100%" 
            height={isMobile ? "450" : "100"}
            style={{ 
              minHeight: isMobile ? '450px' : '88px', 
              maxHeight: isMobile ? '500px' : '120px',
              border: 'none',
              borderRadius: '0.625rem',
              overflow: 'hidden'
            }}
            src={`//www.yelp.com/reservations/drakes-san-carlos/widget?orientation=${isMobile ? 'vertical' : 'horizontal'}&color-scheme=light`}
            title="Make a reservation"
          >
            <a href="https://www.yelp.com/reservations/drakes-san-carlos">Reserve at Drakes on Yelp</a>
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default Reservations; 